/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { css } from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: contents;
  }
`;

/**
 * Estilização do componente animation
 */
const animation = css`
  animation: slide 0.5s forwards;
  @keyframes slide {
    0% {
      transform: translateY(0px);
      opacity: 0 !important;
    }
    50% {
      transform: translateY(50px);
    }
    100% {
      transform: translateY(0px);
      opacity: 1 !important;
    }
  }
`;

/**
 * Estilização do componente Content
 */
export const Content = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  left: 0px;
  z-index: 1600;
  ${animation}

  .react-swipeable-view-container {
    box-shadow: none !important;
  }

  .top-icon {
    text-align: center;
  }
`;

/**
 * Estilização do componente Title
 */
export const Title = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1600;
  height: 56px;
  overflow: hidden;
  display: flex;
  margin-bottom: 10px;

  h1 {
    padding: 16px 16px 16px 0;
    margin: 0;
    color: ${({ theme }) => theme.icons};
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
  }

  > button {
    background: none;
    border: none;
    padding: 16px;

    svg {
      path {
        fill: ${({ theme }) => theme.icons};
      }
    }
  }
`;
